/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import Text from '@atlaskit/ds-explorations/text';
import LockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
import Lozenge from '@atlaskit/lozenge';
import Inline from '@atlaskit/primitives/inline';
var headingStyles = css({
  fontSize: "var(--ds-font-size-100, 14px)",
  fontWeight: 'normal',
  letterSpacing: '0',
  lineHeight: "var(--ds-font-lineHeight-200, 20px)",
  textTransform: 'none'
});

/**
 * __Header items__
 *
 * Comment header items.
 *
 * @internal
 */
var Header = function Header(_ref) {
  var author = _ref.author,
    edited = _ref.edited,
    isError = _ref.isError,
    isSaving = _ref.isSaving,
    restrictedTo = _ref.restrictedTo,
    savingText = _ref.savingText,
    time = _ref.time,
    testId = _ref.testId,
    type = _ref.type,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? '3' : _ref$headingLevel;
  var Heading = "h".concat(Number(headingLevel) < 1 || Number(headingLevel) > 6 ? '3' : headingLevel);
  var shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
  return shouldRender ? jsx(Heading, {
    css: headingStyles
  }, jsx(Inline, {
    alignBlock: "center",
    testId: testId,
    space: "space.100",
    as: "span"
  }, author, type && jsx(Lozenge, {
    testId: testId && "".concat(testId, "-type")
  }, type), time && !isSaving && !isError && time, edited || null, isSaving ? savingText : null, restrictedTo && jsx(Text, {
    as: "span",
    color: "subtlest"
  }, jsx(Inline, {
    alignBlock: "center",
    space: "space.050"
  }, "\u2022", jsx(LockFilledIcon, {
    label: "",
    size: "small"
  }), restrictedTo)))) : null;
};
Header.displayName = 'CommentHeader';
export default Header;